import React from 'react';
export const TranscriptQueryViewContext = React.createContext({});
export function useTranscriptQueryViewContext() {
    return React.useContext(TranscriptQueryViewContext);
}
